var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivePlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C15 8.55 14.55 9 14 9H9V14C9 14.55 8.55 15 8 15C7.45 15 7 14.55 7 14V9H2C1.45 9 1 8.55 1 8C1 7.45 1.45 7 2 7H7V2C7 1.45 7.45 1 8 1C8.55 1 9 1.45 9 2V7H14C14.55 7 15 7.45 15 8Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePlusIcon);
export default __webpack_public_path__ + "static/media/active-plus-icon.f5f96b49533d4f9d23c679dae06f85a2.svg";
export { ForwardRef as ReactComponent };